// src/ui/components/Icons.jsx
import React from "react";

/* =========================
   Logo – Graduation cap
   ========================= */
export function LogoIcon({ className = "h-9 w-9" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path
        d="M3 9l9-4 9 4-9 4-9-4Z"
        className="fill-slate-900 dark:fill-white"
      />
      <path
        d="M7 11.5v4c0 1.1 2.5 2 5 2s5-.9 5-2v-4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21 10v4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/* =========================
   Theme icons
   ========================= */
export function SunIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
      <path
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
      />
    </svg>
  );
}

export function MoonIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
      <path
        d="M21 12.8A9 9 0 1111.2 3a7 7 0 009.8 9.8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/* =========================
   Share – Diagonal arrow
   ========================= */
export function ShareIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <circle cx="18" cy="5" r="3" stroke="currentColor" strokeWidth="2" />
      <circle cx="6" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
      <circle cx="18" cy="19" r="3" stroke="currentColor" strokeWidth="2" />

      <path
        d="M8.7 10.9L15.3 6.1M8.7 13.1L15.3 17.9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/* =========================
   Clipboard – Copy icon
   ========================= */
export function ClipboardIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path
        d="M9 5h6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9 3h6a2 2 0 012 2v2a2 2 0 01-2 2H9a2 2 0 01-2-2V5a2 2 0 012-2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M7 7H6a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V9a2 2 0 00-2-2h-1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/* =========================
   Menu
   ========================= */
export function MenuIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
      <path
        d="M4 6h16M4 12h16M4 18h16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/* =========================
   PayPal
   ========================= */
export function PayPalIcon({ className = "h-5 w-5" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden
    >
      <path d="M7.5 20.5h2.2l.5-3.2h1.6c3.7 0 6.5-1.9 7.3-5.6.4-1.8.1-3.3-.8-4.3-.9-1-2.4-1.4-4.3-1.4H8.3c-.4 0-.8.3-.9.7L4.7 18.6c-.1.4.2.8.6.8h2.2l.5-3.2h-.5l-.5 3.3z" />
    </svg>
  );
}

export function GoogleIcon(props) {
  return (
    <svg viewBox="0 0 48 48" aria-hidden="true" {...props}>
      <path
        fill="#FFC107"
        d="M43.611 20.083H42V20H24v8h11.303C33.73 32.658 29.18 36 24 36c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.957 3.043l5.657-5.657C34.318 6.053 29.42 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"
      />
      <path
        fill="#FF3D00"
        d="M6.306 14.691l6.571 4.819C14.655 16.108 19.02 12 24 12c3.059 0 5.842 1.154 7.957 3.043l5.657-5.657C34.318 6.053 29.42 4 24 4c-7.682 0-14.345 4.34-17.694 10.691z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.087 0 9.805-1.949 13.328-5.122l-6.153-5.207C29.115 35.091 26.715 36 24 36c-5.159 0-9.699-3.32-11.196-7.946l-6.52 5.025C9.567 39.556 16.227 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.611 20.083H42V20H24v8h11.303a12.06 12.06 0 0 1-4.128 5.671l.003-.002 6.153 5.207C36.897 39.27 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"
      />
    </svg>
  );
}

export function MicrosoftIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path fill="#F25022" d="M2 2h9v9H2z" />
      <path fill="#7FBA00" d="M13 2h9v9h-9z" />
      <path fill="#00A4EF" d="M2 13h9v9H2z" />
      <path fill="#FFB900" d="M13 13h9v9h-9z" />
    </svg>
  );
}

export function GitHubIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path
        fill="currentColor"
        d="M12 .5C5.73.5.75 5.64.75 12.02c0 5.12 3.14 9.47 7.5 11.01.55.1.75-.24.75-.53
           0-.26-.01-1.12-.02-2.04-3.05.67-3.69-1.2-3.69-1.2-.5-1.29-1.22-1.63-1.22-1.63-1-.7.08-.69.08-.69
           1.11.08 1.69 1.16 1.69 1.16.98 1.72 2.58 1.22 3.21.93.1-.72.39-1.22.7-1.5-2.43-.28-4.99-1.24-4.99-5.52
           0-1.22.42-2.22 1.1-3-.11-.28-.48-1.41.1-2.93 0 0 .9-.29 2.95 1.13.86-.25 1.78-.37 2.7-.38.92.01
           1.84.13 2.7.38 2.05-1.42 2.95-1.13 2.95-1.13.58 1.52.21 2.65.1 2.93.69.78 1.1 1.78 1.1 3
           0 4.29-2.57 5.23-5.01 5.51.4.35.75 1.03.75 2.08 0 1.5-.02 2.7-.02 3.07 0 .29.2.64.76.53
           4.36-1.54 7.5-5.9 7.5-11.01C23.25 5.64 18.27.5 12 .5z"
      />
    </svg>
  );
}

/* =========================
   Account – user icon
   ========================= */
export function AccountIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path
        d="M20 21a8 8 0 10-16 0"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

export function CrownIcon({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden className={className}>
      <path
        d="M4 8l4 4 4-6 4 6 4-4v10H4V8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M4 18h16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="6" cy="8" r="1" fill="currentColor" />
      <circle cx="12" cy="6" r="1" fill="currentColor" />
      <circle cx="18" cy="8" r="1" fill="currentColor" />
    </svg>
  );
}

export function PinIcon({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path
        d="M14 4l6 6-2 2-2-2-4 4v4l-2 2v-6l-2-2H2l2-2h4l4-4-2-2 2-2z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function StarIcon({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path
        d="M12 3l2.6 5.6 6.1.7-4.5 4 1.3 6-5.5-3.1-5.5 3.1 1.3-6-4.5-4 6.1-.7L12 3z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DiceframeIcon({ className = "h-4 w-4" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      className={className}
      aria-hidden
      fill="none"
      style={{ color: "#2F3A44" }} // dark grey default
    >
      <g>
        {/* main dark shape */}
        <path
          d="M 9.480469 18.335938 C 12.992188 20.046875 16.433594 21.851562 19.839844 23.777344 C 22.070312 25.039062 24.316406 26.269531 26.5625 27.503906 C 26.964844 27.726562 27.367188 27.949219 27.773438 28.171875 C 29.964844 29.378906 29.964844 29.378906 32.167969 30.5625 C 32.191406 33.296875 32.210938 36.03125 32.222656 38.765625 C 32.226562 40.035156 32.234375 41.304688 32.246094 42.578125 C 32.257812 44.039062 32.265625 45.5 32.269531 46.960938 C 32.273438 47.414062 32.277344 47.867188 32.285156 48.335938 C 32.285156 48.761719 32.285156 49.1875 32.285156 49.625 C 32.289062 50.183594 32.289062 50.183594 32.292969 50.753906 C 32.148438 51.941406 31.816406 52.613281 31.152344 53.574219 C 30.007812 54.183594 29 54.164062 27.765625 53.933594 C 26.09375 53.230469 24.511719 52.347656 22.921875 51.460938 C 22.464844 51.210938 22.011719 50.964844 21.558594 50.71875 C 20.441406 50.109375 19.328125 49.496094 18.214844 48.878906 C 17.65625 48.566406 17.097656 48.257812 16.539062 47.949219 C 14.96875 47.078125 13.398438 46.203125 11.835938 45.3125 C 10.945312 44.816406 10.042969 44.34375 9.144531 43.863281 C 9.136719 40.589844 9.128906 37.316406 9.125 34.039062 C 9.125 32.519531 9.121094 30.996094 9.117188 29.476562 C 9.113281 28.011719 9.113281 26.542969 9.109375 25.078125 C 9.109375 24.515625 9.109375 23.957031 9.105469 23.394531 C 9.105469 22.613281 9.105469 21.832031 9.105469 21.046875 C 9.105469 20.601562 9.101562 20.15625 9.101562 19.695312 C 9.144531 18.695312 9.144531 18.695312 9.480469 18.335938 Z M 9.480469 18.335938"
          fill="currentColor"
          fillRule="nonzero"
        />

        <path
          d="M 33.183594 6.472656 C 34.222656 6.917969 34.222656 6.917969 35.265625 7.480469 C 35.652344 7.6875 36.039062 7.898438 36.4375 8.109375 C 36.851562 8.335938 37.261719 8.5625 37.671875 8.785156 C 38.097656 9.015625 38.523438 9.246094 38.949219 9.476562 C 40.191406 10.148438 41.429688 10.824219 42.667969 11.503906 C 43.160156 11.777344 43.160156 11.777344 43.664062 12.054688 C 45.484375 13.058594 47.292969 14.074219 49.101562 15.101562 C 49.328125 15.230469 49.558594 15.363281 49.796875 15.496094 C 51.03125 16.199219 52.269531 16.90625 53.503906 17.617188 C 53.503906 17.855469 53.503906 18.09375 53.503906 18.335938 C 49.804688 20.4375 46.085938 22.476562 42.328125 24.449219 C 41.359375 24.957031 40.394531 25.46875 39.429688 25.976562 C 39.210938 26.089844 38.992188 26.207031 38.769531 26.324219 C 38.558594 26.433594 38.351562 26.542969 38.136719 26.65625 C 37.933594 26.765625 37.726562 26.871094 37.519531 26.984375 C 36.898438 27.320312 36.898438 27.320312 36.296875 27.742188 C 35.351562 28.382812 34.695312 28.761719 33.5625 28.777344 C 32.117188 28.265625 30.835938 27.542969 29.503906 26.765625 C 28.921875 26.433594 28.34375 26.101562 27.761719 25.769531 C 27.476562 25.605469 27.1875 25.441406 26.890625 25.273438 C 25.769531 24.636719 24.632812 24.035156 23.492188 23.4375 C 19.695312 21.445312 15.945312 19.34375 12.191406 17.257812 C 12.191406 17.019531 12.191406 16.785156 12.191406 16.539062 C 13.296875 15.925781 14.40625 15.3125 15.511719 14.695312 C 15.855469 14.507812 16.199219 14.316406 16.554688 14.121094 C 18.523438 13.027344 20.496094 11.9375 22.472656 10.855469 C 22.886719 10.628906 23.300781 10.402344 23.714844 10.171875 C 24.515625 9.734375 25.316406 9.296875 26.117188 8.855469 C 26.667969 8.554688 26.667969 8.554688 27.230469 8.246094 C 27.554688 8.066406 27.878906 7.890625 28.214844 7.707031 C 29.128906 7.214844 29.128906 7.214844 29.9375 6.5625 C 31.160156 5.933594 31.878906 6.136719 33.183594 6.472656 Z M 33.183594 6.472656"
          fill="currentColor"
          fillRule="nonzero"
        />

        <path
          d="M 55.535156 20.136719 C 55.535156 21.914062 55.535156 23.695312 55.535156 25.527344 C 54.972656 25.824219 54.414062 26.121094 53.835938 26.425781 C 49.949219 28.476562 46.070312 30.53125 42.257812 32.722656 C 42.015625 32.863281 41.773438 33 41.527344 33.140625 C 41.320312 33.257812 41.113281 33.378906 40.902344 33.5 C 40.296875 33.796875 40.296875 33.796875 38.941406 34.15625 C 38.941406 36.054688 38.941406 37.953125 38.941406 39.910156 C 39.433594 39.648438 39.921875 39.386719 40.429688 39.117188 C 42.242188 38.152344 44.054688 37.1875 45.867188 36.222656 C 46.652344 35.804688 47.441406 35.386719 48.226562 34.96875 C 49.351562 34.367188 50.480469 33.769531 51.605469 33.167969 C 51.960938 32.980469 52.316406 32.792969 52.679688 32.597656 C 53.003906 32.421875 53.328125 32.25 53.664062 32.074219 C 53.953125 31.917969 54.242188 31.765625 54.539062 31.609375 C 55.195312 31.28125 55.195312 31.28125 55.535156 31.28125 C 55.535156 33.0625 55.535156 34.839844 55.535156 36.675781 C 54.972656 36.96875 54.414062 37.265625 53.835938 37.570312 C 49.949219 39.621094 46.070312 41.675781 42.257812 43.871094 C 42.015625 44.007812 41.773438 44.144531 41.527344 44.285156 C 41.320312 44.40625 41.113281 44.523438 40.902344 44.648438 C 40.296875 44.945312 40.296875 44.945312 38.941406 45.304688 C 38.941406 47.796875 38.941406 50.285156 38.941406 52.855469 C 34.921875 55.011719 34.921875 55.011719 34.539062 55.011719 C 34.539062 47.179688 34.539062 39.347656 34.539062 31.28125 C 41.839844 27.324219 41.839844 27.324219 44.113281 26.097656 C 44.722656 25.765625 45.335938 25.433594 45.949219 25.101562 C 46.4375 24.835938 46.4375 24.835938 46.941406 24.5625 C 49.296875 23.28125 51.636719 21.964844 53.957031 20.613281 C 54.855469 20.136719 54.855469 20.136719 55.535156 20.136719 Z M 55.535156 20.136719"
          fill="currentColor"
          fillRule="nonzero"
        />

        {/* light inner cutouts */}
        <path
          d="M 13.882812 25.167969 C 15.890625 25.84375 17.699219 26.777344 19.578125 27.773438 C 19.898438 27.941406 20.21875 28.109375 20.546875 28.28125 C 26.242188 31.304688 26.242188 31.304688 27.765625 33.796875 C 28.164062 35.058594 28.160156 36.203125 28.164062 37.515625 C 28.164062 37.902344 28.164062 37.902344 28.167969 38.292969 C 28.167969 38.839844 28.167969 39.382812 28.167969 39.929688 C 28.167969 40.757812 28.175781 41.589844 28.183594 42.417969 C 28.183594 42.949219 28.183594 43.476562 28.183594 44.007812 C 28.1875 44.253906 28.1875 44.503906 28.191406 44.757812 C 28.183594 46.175781 28.015625 47.257812 27.429688 48.539062 C 25.882812 48.632812 24.914062 48.417969 23.539062 47.671875 C 23.023438 47.394531 23.023438 47.394531 22.496094 47.109375 C 21.960938 46.816406 21.960938 46.816406 21.417969 46.515625 C 21.066406 46.328125 20.71875 46.140625 20.355469 45.949219 C 19.320312 45.386719 18.289062 44.820312 17.269531 44.226562 C 16.984375 44.085938 16.695312 43.949219 16.402344 43.808594 C 14.058594 42.574219 14.058594 42.574219 13.589844 41.222656 C 13.492188 40.183594 13.503906 39.203125 13.554688 38.160156 C 13.558594 37.789062 13.5625 37.417969 13.566406 37.03125 C 13.585938 35.847656 13.628906 34.667969 13.671875 33.484375 C 13.6875 32.679688 13.703125 31.875 13.71875 31.070312 C 13.753906 29.101562 13.8125 27.136719 13.882812 25.167969 Z M 13.882812 25.167969"
          fill="#FAFAFA"
          fillRule="nonzero"
        />

        <path
          d="M 33.183594 9.707031 C 33.914062 10.03125 33.914062 10.03125 34.648438 10.429688 C 34.921875 10.578125 35.199219 10.726562 35.484375 10.882812 C 35.925781 11.121094 35.925781 11.121094 36.375 11.371094 C 36.679688 11.535156 36.984375 11.699219 37.300781 11.871094 C 37.941406 12.21875 38.585938 12.570312 39.226562 12.921875 C 40.210938 13.460938 41.199219 13.996094 42.1875 14.527344 C 42.808594 14.867188 43.433594 15.207031 44.058594 15.550781 C 44.355469 15.710938 44.652344 15.871094 44.957031 16.035156 C 45.230469 16.183594 45.503906 16.335938 45.78125 16.488281 C 46.144531 16.6875 46.144531 16.6875 46.511719 16.886719 C 47.070312 17.257812 47.070312 17.257812 47.40625 17.976562 C 47.066406 18.15625 46.726562 18.335938 46.378906 18.523438 C 45.113281 19.191406 43.847656 19.859375 42.582031 20.53125 C 42.035156 20.820312 41.488281 21.109375 40.941406 21.398438 C 40.152344 21.8125 39.367188 22.230469 38.578125 22.648438 C 38.335938 22.777344 38.09375 22.902344 37.839844 23.035156 C 37.609375 23.15625 37.378906 23.28125 37.144531 23.40625 C 36.925781 23.519531 36.710938 23.636719 36.484375 23.753906 C 35.824219 24.113281 35.824219 24.113281 34.984375 24.742188 C 34.199219 25.167969 34.199219 25.167969 33.410156 25.140625 C 32.191406 24.695312 31.054688 24.105469 29.90625 23.488281 C 29.660156 23.355469 29.414062 23.222656 29.15625 23.089844 C 28.636719 22.808594 28.113281 22.53125 27.589844 22.25 C 26.800781 21.824219 26.007812 21.402344 25.214844 20.976562 C 24.703125 20.707031 24.195312 20.433594 23.683594 20.160156 C 23.449219 20.035156 23.214844 19.910156 22.976562 19.78125 C 21.496094 18.988281 20.058594 18.140625 18.625 17.257812 C 18.625 17.019531 18.625 16.785156 18.625 16.539062 C 18.832031 16.421875 19.042969 16.308594 19.257812 16.1875 C 19.882812 15.84375 20.511719 15.496094 21.136719 15.152344 C 21.847656 14.757812 22.5625 14.363281 23.273438 13.972656 C 24.859375 13.09375 26.441406 12.214844 28 11.285156 C 28.230469 11.148438 28.457031 11.015625 28.695312 10.875 C 29.292969 10.515625 29.890625 10.152344 30.488281 9.789062 C 31.644531 9.28125 32.003906 9.367188 33.183594 9.707031 Z M 33.183594 9.707031"
          fill="#FAFAFA"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

/* =========================
   Support – Lifebuoy / Help
   ========================= */
export function SupportIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      {/* Outer ring */}
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="2"
      />
      {/* Inner ring */}
      <circle
        cx="12"
        cy="12"
        r="4"
        stroke="currentColor"
        strokeWidth="2"
      />

      {/* Lifebuoy segments */}
      <path
        d="M17.66 6.34l-2.83 2.83M9.17 14.83l-2.83 2.83M6.34 6.34l2.83 2.83M14.83 14.83l2.83 2.83"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}